import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import "../component/pages/Job/ProcessTable.css";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { formattedEditDate } from "./formattedDate";
import { DeleteModal } from "./DeleteModal";

import {
  idleCode,
  machineData,
  processList,
  toolListTapping,
  userName,
} from "./Data";
import { formatDecimalMinutesToMinutesSeconds } from "../utils/timeHelper";

function TappingTable({
  processTableData,
  handleTextFieldChange,
  handleIdleTimeChange,
  processTableErrors,
  containerIndex,
  calculateCT,
  handleDeleteConfirm,
  addIdleCode,
  deleteModalState,
  handleDeleteCancel,
  handleDeleteClick,
  calculateTimeDifference,
}) {
  return (
    <>
      <Table sx={{ minWidth: 2800 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Sr.No</TableCell>
            <TableCell align="center">Process</TableCell>
            <TableCell align="center">Description</TableCell>
            <TableCell align="center">Machine Name</TableCell>
            <TableCell align="center">Tooling Used</TableCell>

            <TableCell align="center">DIA</TableCell>
            <TableCell align="center">RPM</TableCell>
            <TableCell align="center">Feed(MM/MIN)</TableCell>
            <TableCell align="center">Length</TableCell>

            <TableCell align="center">NOH</TableCell>

            <TableCell align="center">Estimated CT(min)</TableCell>
            <TableCell align="center">Required Dimension</TableCell>
            <TableCell align="center">Actual Dimension</TableCell>
            <TableCell align="center">Start Date</TableCell>
            <TableCell align="center">Start Time</TableCell>
            <TableCell align="center">End Date</TableCell>
            <TableCell align="center">End Time</TableCell>

            <TableCell align="center">Actual CT(min)</TableCell>
            <TableCell align="center">User Name</TableCell>
            <TableCell align="center">Remark</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {processTableData &&
            processTableData?.map((row, rowIndex) => (
              <>
                <TableRow
                  key={rowIndex}
                  style={{
                    color: "#fff",
                    backgroundColor:
                      !isNaN(row?.actualCT) && row?.actualCT !== 0
                        ? row?.estimatedCT >= row?.actualCT
                          ? "#a7f3d0"
                          : "#FE8A96"
                        : "inherit",
                  }}
                >
                  <TableCell align="center">{rowIndex + 1}</TableCell>

                  <TableCell align="center">
                    <Select
                      labelId={`process-label-${rowIndex}`}
                      size="small"
                      id={`process-${rowIndex}`}
                      value={row.process}
                      name={`process-${rowIndex}`}
                      className="input"
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "process",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.process}
                    >
                      {processList.map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={processTableErrors[rowIndex]?.process}
                    >
                      {processTableErrors[rowIndex]?.process
                        ? "This field is required"
                        : ""}
                    </FormHelperText>
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="Description"
                      className="input"
                      size="small"
                      name={`description-${rowIndex}`}
                      value={row.description}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "description",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.description}
                      helperText={
                        processTableErrors[rowIndex]?.description
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Select
                      labelId={`machineName-label-${rowIndex}`}
                      className="input"
                      size="small"
                      id={`machineName-${rowIndex}`}
                      value={row.machineName}
                      name={`machineName-${rowIndex}`}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "machineName",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.machineName}
                    >
                      {machineData.map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={processTableErrors[rowIndex]?.machineName}
                    >
                      {processTableErrors[rowIndex]?.machineName
                        ? "This field is required"
                        : ""}
                    </FormHelperText>
                  </TableCell>

                  <TableCell align="center">
                    <Select
                      labelId={`toolingUsed-label-${rowIndex}`}
                      className="input"
                      size="small"
                      id={`toolingUsed-${rowIndex}`}
                      value={row.toolingUsed} // Ensure that value is an array
                      name={`toolingUsed-${rowIndex}`}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "toolingUsed",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.toolingUsed}
                    >
                      {toolListTapping.map((name) => (
                        <MenuItem key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={processTableErrors[rowIndex]?.toolingUsed}
                    >
                      {processTableErrors[rowIndex]?.toolingUsed
                        ? "This field is required"
                        : ""}
                    </FormHelperText>
                  </TableCell>

                  <TableCell align="center">
                    <TextField
                      label="dia"
                      className="fixed-width-input"
                      size="small"
                      name={`dia-${rowIndex}`}
                      value={row.dia}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "dia",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.dia}
                      helperText={
                        processTableErrors[rowIndex]?.dia
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="rpm"
                      className="fixed-width-input"
                      size="small"
                      name={`rpm-${rowIndex}`}
                      value={row.rpm}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "rpm",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.rpm}
                      helperText={
                        processTableErrors[rowIndex]?.rpm
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="feed"
                      className="fixed-width-input"
                      size="small"
                      name={`feed-${rowIndex}`}
                      value={row.feed}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "feed",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.feed}
                      helperText={
                        processTableErrors[rowIndex]?.feed
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="length"
                      className="fixed-width-input"
                      size="small"
                      name={`length-${rowIndex}`}
                      value={row.length}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "length",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.length}
                      helperText={
                        processTableErrors[rowIndex]?.length
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>

                  <TableCell align="center">
                    <TextField
                      label="noh"
                      className="fixed-width-input"
                      size="small"
                      name={`noh-${rowIndex}`}
                      value={row.noh}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "noh",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.noh}
                      helperText={
                        processTableErrors[rowIndex]?.noh
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>

                  <TableCell align="center">
                    <TextField
                      label="EstimatedCT"
                      className="fixed-width-input"
                      size="small"
                      name={`estimatedCT-${rowIndex}`}
                      value={formatDecimalMinutesToMinutesSeconds(
                        row.estimatedCT
                      )}
                      disabled
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "estimatedCT",
                          containerIndex,
                          "Tapping"
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="requiredDimension"
                      className="fixed-width-input"
                      size="small"
                      disabled
                      name={`requiredDimension-${rowIndex}`}
                      value={row?.requiredDimension}
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "requiredDimension",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.requiredDimension}
                      helperText={
                        processTableErrors[rowIndex]?.requiredDimension
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="actualDimension"
                      className="fixed-width-input"
                      size="small"
                      name={`actualDimension-${rowIndex}`}
                      value={row?.actualDimension}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "actualDimension",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "actualDimension",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.actualDimension}
                      helperText={
                        processTableErrors[rowIndex]?.actualDimension
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="startDate"
                      className="fixed-width-input"
                      size="small"
                      type="date"
                      name={`startDate-${rowIndex}`}
                      value={formattedEditDate(row.startDate)}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "startDate",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "startDate",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      // inputProps={{
                      //   min: new Date().toISOString().split("T")[0],
                      // }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="startTime"
                      size="small"
                      className="fixed-width-input"
                      type="time"
                      name={`startTime-${rowIndex}`}
                      value={row.startTime}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "startTime",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "startTime",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="endDate"
                      size="small"
                      type="date"
                      name={`endDate-${rowIndex}`}
                      className="fixed-width-input"
                      value={formattedEditDate(row.endDate)}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "endDate",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "endDate",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      // inputProps={{
                      //   min: new Date().toISOString().split("T")[0],
                      // }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      label="endTime"
                      size="small"
                      type="time"
                      name={`endTime-${rowIndex}`}
                      className="fixed-width-input"
                      value={row.endTime}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "endTime",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "endTime",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </TableCell>

                  <TableCell align="center">
                    <TextField
                      label="ActualCT"
                      className="fixed-width-input"
                      size="small"
                      name={`actualCT-${rowIndex}`}
                      value={formatDecimalMinutesToMinutesSeconds(row.actualCT)}
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "actualCT",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "actualCT",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      error={processTableErrors[rowIndex]?.actualCT}
                      helperText={
                        processTableErrors[rowIndex]?.actualCT
                          ? "This field is required"
                          : ""
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      id={`userName-${rowIndex}`}
                      value={row.userName || ""}
                      className="input"
                      label="UserName"
                      size="small"
                      name={`userName-${rowIndex}`}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "userName",
                          containerIndex,
                          "Milling"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "userName",
                          containerIndex,
                          "Milling"
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <TextField
                      id="outlined-textarea"
                      label="Remark"
                      className="input"
                      size="small"
                      name={`remark-${rowIndex}`}
                      value={row.remark}
                      onBlur={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "remark",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      onChange={(e) =>
                        handleTextFieldChange(
                          e,
                          rowIndex,
                          "remark",
                          containerIndex,
                          "Tapping"
                        )
                      }
                      placeholder="Enter Remark"
                      multiline
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: 0 }} colSpan={10}>
                    <Box margin={1} sx={{ overflowX: "auto" }}>
                      <Table
                        size="small"
                        aria-label="idle-codes"
                        sx={{ minWidth: 1000 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" sx={{ width: "120px" }}>
                              Sr.No
                            </TableCell>
                            <TableCell align="center" sx={{ width: "200px" }}>
                              Idle Code
                            </TableCell>
                            <TableCell align="center" sx={{ width: "150px" }}>
                              Start Date
                            </TableCell>
                            <TableCell align="center" sx={{ width: "150px" }}>
                              Start Time
                            </TableCell>
                            <TableCell align="center" sx={{ width: "150px" }}>
                              End Date
                            </TableCell>
                            <TableCell align="center" sx={{ width: "150px" }}>
                              End Time
                            </TableCell>
                            <TableCell align="center" sx={{ width: "150px" }}>
                              Total Time (min)
                            </TableCell>
                            <TableCell align="center" sx={{ width: "100px" }}>
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(row?.idleCode || []).map((idle, idleIndex) => (
                            <TableRow key={idleIndex}>
                              <TableCell align="center">
                                Idle Code {idleIndex + 1}
                              </TableCell>
                              <TableCell align="center" sx={{ width: "200px" }}>
                                <Select
                                  value={idle?.name || ""}
                                  onChange={(e) => {
                                    const newIdleCodes = [
                                      ...(row.idleCode || []),
                                    ];
                                    newIdleCodes[idleIndex] = {
                                      ...newIdleCodes[idleIndex],
                                      code: e.target.value,
                                      name: e.target.value, // assuming you want to update name as well
                                    };

                                    handleTextFieldChange(
                                      {
                                        target: {
                                          name: "idleCode",
                                          value: newIdleCodes,
                                        },
                                      },
                                      rowIndex,
                                      "idleCode",
                                      containerIndex,
                                      "Milling"
                                    );
                                  }}
                                  onBlur={(e) => {
                                    const newIdleCodes = [
                                      ...(row.idleCode || []),
                                    ];
                                    newIdleCodes[idleIndex] = {
                                      ...newIdleCodes[idleIndex],
                                      code: e.target.value,
                                      name: e.target.value, // assuming you want to update name as well
                                    };

                                    handleTextFieldChange(
                                      {
                                        target: {
                                          name: "idleCode",
                                          value: newIdleCodes,
                                        },
                                      },
                                      rowIndex,
                                      "idleCode",
                                      containerIndex,
                                      "Milling"
                                    );
                                  }}
                                  size="small"
                                  sx={{ width: "100%", minWidth: "180px" }}
                                >
                                  {idleCode?.map((code) => (
                                    <MenuItem key={code.id} value={code.name}>
                                      {code?.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </TableCell>
                              <TableCell sx={{ width: "150px" }} align="center">
                                <TextField
                                  type="date"
                                  value={
                                    formattedEditDate(idle.startDate) || ""
                                  }
                                  onChange={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "startDate",
                                      containerIndex
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "startDate",
                                      containerIndex
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell sx={{ width: "150px" }} align="center">
                                <TextField
                                  type="time"
                                  value={idle.startTime || ""}
                                  onChange={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "startTime",
                                      containerIndex
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "startTime",
                                      containerIndex
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell sx={{ width: "150px" }} align="center">
                                <TextField
                                  type="date"
                                  value={formattedEditDate(idle.endDate) || ""}
                                  onChange={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "endDate",
                                      containerIndex
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "endDate",
                                      containerIndex
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell sx={{ width: "150px" }} align="center">
                                <TextField
                                  type="time"
                                  value={idle.endTime || ""}
                                  onChange={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "endTime",
                                      containerIndex
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleIdleTimeChange(
                                      e,
                                      rowIndex,
                                      idleIndex,
                                      "endTime",
                                      containerIndex
                                    )
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  size="small"
                                  fullWidth
                                />
                              </TableCell>
                              <TableCell sx={{ width: "150px" }} align="center">
                                {idle.timeDifference !== null &&
                                idle.timeDifference !== undefined
                                  ? idle.timeDifference
                                  : calculateTimeDifference(
                                      idle.startDate,
                                      idle.startTime,
                                      idle.endDate,
                                      idle.endTime
                                    )}
                              </TableCell>
                              <TableCell align="center">
                                <IconButton
                                  onClick={() =>
                                    handleDeleteClick(
                                      rowIndex,
                                      idleIndex,
                                      containerIndex
                                    )
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={24}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        backgroundColor: "#1d5393",
                        color: "#fff",
                        minWidth: "200px",
                        "&:hover": { backgroundColor: "#245BA1" },
                        "&:active": { backgroundColor: "#1d5393" },
                      }}
                      startIcon={<AddIcon />}
                      onClick={() =>
                        addIdleCode(rowIndex, containerIndex, "Milling")
                      }
                    >
                      Add Idle Code
                    </Button>
                  </TableCell>
                </TableRow>
              </>
            ))}
        </TableBody>
        <DeleteModal
          open={deleteModalState.open}
          handleClose={handleDeleteCancel}
          onConfirm={handleDeleteConfirm}
        />
      </Table>
    </>
  );
}

export default TappingTable;
